<template lang="pug">
.register-row.form-label
  .register-group
    .register-key
      span.key-name ADL
    .register-value(v-if="value")
      b-table-simple.dark-boder-table.table.b-table(style="width: 300px;")
        b-tbody
          b-tr
            b-td.move
              div(style="font-weight: bold;") 移動
            b-td.value
              div(v-if="value.move") {{ convertAdlType(value.move) }}
              div.warning-message(v-else) 未設定
          b-tr
            b-td.move
              div(style="font-weight: bold;") 食事
            b-td.value
              div(v-if="value.meel") {{ convertAdlType(value.meel) }}
              div.warning-message(v-else) 未設定
          b-tr
            b-td.move
              div(style="font-weight: bold;") 入浴
            b-td.value
              div(v-if="value.bathing") {{ convertAdlType(value.bathing) }}
              div.warning-message(v-else) 未設定
          b-tr
            b-td.move
              div(style="font-weight: bold;") 排せつ
            b-td.value
              div(v-if="value.excretion") {{ convertAdlType(value.excretion) }}
              div.warning-message(v-else) 未設定
    .register-value(v-else)
      span.error-message 未設定
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { AdlType } from "@/commons/services/OtherOfficeAcceptanceRequests";

/**
 * ラベルのみコンポーネント
 *
 * - ラベルと値を表示するのみ
 * - 入力要素コンポーネントと同じレイアウトをサポートする
 */
@Component
export default class LabelAdl extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: any;

  get _value(): string {
    return this.value;
  }

  convertAdlType(adlType: AdlType) {
    switch (adlType) {
      /** 自立 */
      case AdlType.HEALTHINESS: {
        return "自立";
      }
      /** 見守り */
      case AdlType.MONITORING: {
        return "見守り";
      }
      /** 一部介助 */
      case AdlType.PARTIAL_ASSISTANCE: {
        return "一部介助";
      }
      /** 全介助 */
      case AdlType.FULL_ASSISTANCE: {
        return "全介助";
      }
      default: {
        return "";
      }
    }
  }
}
</script>
